import React, { useState, useEffect } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import VerticalLine from "../../common/images-new/vertical-line.svg";
import { MenuItem, Select, styled } from "@mui/material";
import DPEditor from "../../components/Editor/DPEditor";
import Swal from "sweetalert2";
import { Add, Remove } from "@material-ui/icons";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import {
  ButtonCommonDelete,
  ButtonCommonTop,
  ButtonCommonTopNew,
  Card,
} from "../Theme";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { FaTrashAlt } from "react-icons/fa";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Tooltip from "@mui/material/Tooltip";
import { toast } from "react-toastify";

const responseOptions = [
  {
    label: "No response required",
    value: 0,
  },
  {
    label: "Response required",
    value: 1,
  },
];

export default function NewTask(props) {

  const [taskName, setTaskName] = useState(props.item.task_name);
  const [isEditing, setisEditing] = useState(false);

  const [expandCollapse, setexpandCollapse] = useState(false);

  const onTitleChange = (e) => {
    props.setTaskData && props.setTaskData(props.index, 1, e.target.value);
  };
  const onOptionChange = (e) => {
    props.setTaskData && props.setTaskData(props.index, 2, e.target.value);
  };

  const onDetailChange = (text) => {
    // setTaskDetail(text);
    props.setTaskData(props.index, 0, text);
  };

  const handleDeleteData = (id) => {
    Swal.fire({
      title: "Delete Task Confirmation",
      icon: "warning",
      heightAuto: false,
      text: "Are you sure to delete this task?",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        props.setTaskData(props.index, 3, id);
      }
    });
  };

  const Up = () => {
    props.setTaskData(props.index, 4, "up");
  };

  const Down = () => {
    props.setTaskData(props.index, 4, "down");
  };

  const ExpandCollapse = () => {
    setexpandCollapse(!expandCollapse);
  };

  const handleFocus = (e) => {
      e.preventDefault();
      if (taskName.trim() !== "") {
        onTitleChange(taskName);
        setisEditing(false);
      } else {
        toast.error("Please enter the task name");
      }
    };

  return (
    <Card className="flex p-5 flex-col  border20px">
          <div
            className={`mb-3  flex items-center gap-3 flex-wrap justify-between `}
          >
            {/* backGroundColor px-3 py-2 rounded-lg */}
            {isEditing ? (
              <input
                type="text"
                onBlur={handleFocus}
                className="px-2 py-1 border border-gray-300 rounded"
                placeholder="Task name"
                value={taskName}
                autoFocus
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleFocus(e); // 👈 your custom function
                  }
                }}
                onChange={(e) => {
                  setTaskName(e.target.value);
                }}
              />
            ) : (
              <span
                className="cursor-pointer flex gap-2 font-semibold items-center  blackColor text-lg"
                onClick={() => {
                  setisEditing(true);
                }}
              >
                {taskName}
                <Tooltip title={"Edit task name"} placement="top" arrow>
                  <BorderColorOutlinedIcon
                    fontSize="small"
                    className="w-4 h-4 cursor-pointer mt-1 primaryIcon editIcon"
                  />
                </Tooltip>
              </span>
            )}
            <div className="flex items-center gap-3 ">
              <Select
                value={props.item.task_response}
                onChange={onOptionChange}
                displayEmpty
                className="roundedModel font-semibold text-xs lg:text-sm border-gray-300 bg-white"
                style={{ height: "35px", padding: 0, minWidth: "0" }}
                inputProps={{ "aria-label": "Without label" }}
                IconComponent={KeyboardArrowDownIcon}
                sx={{
                  "& .MuiSelect-select": {
                    padding: "6px 28px 6px 8px !important",
                    borderRadius: "0.5rem !important",
                    fontSize: "14px !important",
                    fontWeight: "500 !important",
                    display: "flex",
                    alignItems: "center",
                    display: "block", // 👈 needed for ellipsis
                    whiteSpace: "nowrap !important",
                    overflow: "hidden !important",
                    textOverflow: "ellipsis !important",
                  },
                  "& .MuiSelect-icon": {
                    right: "4px",
                  },
                  "& .MuiMenuItem-root": {
                    whiteSpace: "normal", // 👈 allow full wrap in dropdown menu
                    wordBreak: "break-word",
                  },
                }}
                 MenuProps={{
                                                    disableScrollLock: true,
                                                }}
              >
                {responseOptions?.map((i, index) => (
                  <MenuItem key={index} value={i.value}>
                    {i.label}
                  </MenuItem>
                ))}
              </Select>
              {/* <Tooltip title={"Move up"} placement="top" arrow>
                  <ButtonCommonTopNew
                    onClick={Up}
                    className="rounded-md w-8 h-8 flex justify-center items-center cursor-pointer"
                  >
                    <ArrowUpwardIcon
                      style={{ fontSize: "18px" }}
                      className="blueColor "
                    />
                  </ButtonCommonTopNew>
                </Tooltip>
                <Tooltip title={"Move down"} placement="top" arrow>
                  <ButtonCommonTopNew
                    onClick={Down}
                    className="rounded-md w-8 h-8 flex justify-center items-center cursor-pointer"
                  >
                    <ArrowDownwardIcon
                      style={{ fontSize: "18px" }}
                      className="blueColor "
                    />
                  </ButtonCommonTopNew>
                </Tooltip> */}
              <Tooltip title={"Delete"} placement="top" arrow>
                <ButtonCommonDelete
                  className="rounded-md w-8 h-8 flex justify-center items-center cursor-pointer"
                  onClick={() => handleDeleteData(props.item.task_id)}
                >
                  <FaTrashAlt
                    style={{ fontSize: "14px" }}
                    className="deleteColor"
                  />
                </ButtonCommonDelete>
              </Tooltip>
            </div>
          </div>
          <div className="grid">
            <DPEditor
              content={props.item.task_detail}
              setContent={onDetailChange}
              height={350}
            />
          </div>
        </Card>
  );
}
